import { render, staticRenderFns } from "./201128.vue?vue&type=template&id=2fad79e3&scoped=true"
import script from "./201128.vue?vue&type=script&lang=js"
export * from "./201128.vue?vue&type=script&lang=js"
import style0 from "./201128.vue?vue&type=style&index=0&id=2fad79e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad79e3",
  null
  
)

export default component.exports